import { useReduxState } from 'hooks';
import {
  HomePageSettingsModulesModuleFooter,
  HomePageSettingsModulesModuleUpdateSettings,
  HomePageSettingsTilesPaths
} from '.';

import type { ModuleInSettings } from './HomePageSettingsModules';

interface Props {
  module: ModuleInSettings;
  updateModule: (module: ModuleInSettings) => void;
}

const HomePageSettingsModulesModulePathsAvailable = ({
  module,
  updateModule
}: Props) => {
  const { messages } = useReduxState();

  const url = `/admin/paths?pathType=available&page=1&limit=${module.limit}`;

  return (
    <div>
      <HomePageSettingsTilesPaths module={module} url={url} />

      <HomePageSettingsModulesModuleFooter
        items={[
          {
            label: messages.homePageSettingsModulesNumberOfPaths,
            value: `${messages.homePageSettingsModulesLimitMax} ${module.limit}`
          }
        ]}
      >
        <HomePageSettingsModulesModuleUpdateSettings
          module={module}
          onUpdate={updateModule}
          productType="path"
        />
      </HomePageSettingsModulesModuleFooter>
    </div>
  );
};

export default HomePageSettingsModulesModulePathsAvailable;
